<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="ml-n3 mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="font-weight-regular text-capitalize">
                {{ viewType }} Log
            </h2>
        </v-card-title>
        <v-divider class="mx-6" />
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-0 mt-7"
                :mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
            >
                <template v-slot:top>
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pt-4 pb-0 pb-4"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <v-col cols="6" class="d-flex align-center">
                            <h2
                                class="my-n3 d-flex align-center text-capitalize"
                            >
                                {{ viewType }} Entries
                            </h2></v-col
                        >
                    </v-row>
                </template>
                <!--ITEMS-->
                <template v-slot:[`item.index`]="{ index }">
                    <p class="my-0">
                        {{ index + 1 }}
                    </p>
                </template>
                <template v-slot:[`item.date`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{
                                item.date
                                    ? formatDate(
                                          item.date.seconds ||
                                              item.date._seconds
                                      )
                                    : ''
                            }}
                        </p>
                    </div>
                </template>
                <!-- PRODUCTION -->
                <template v-slot:[`item.operator`]="{ item }">
                    <div>
                        <p class="my-0">
                            {{ displayUser(item, item.operator) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.process`]="{ item }">
                    <div>
                        <p class="my-0">{{ item.process }}</p>
                    </div>
                </template>
                <template v-slot:[`item.machine`]="{ item }">
                    <div>
                        <p class="my-0">{{ item.machine }}</p>
                    </div>
                </template>
                <template v-slot:[`item.qty`]="{ item }">
                    <div>
                        <p class="my-0">{{ item.qty }}</p>
                    </div>
                </template>
                <!-- DELIVERY -->
                <template v-slot:[`item.originProcess`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ item.originProcess }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.originUser`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ displayUser(item, item.originUser) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.destinationProcess`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ item.destinationProcess }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.destUser`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ displayUser(item, item.destUser) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.destUserOn`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{
                                item.destUserOn
                                    ? formatDate(
                                          item.destUserOn._seconds ||
                                              item.destUserOn.seconds
                                      )
                                    : ''
                            }}
                        </p>
                    </div>
                </template>
                <!-- QUALITY -->
                <template v-slot:[`item.qualityUser`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ getUserName(item.qualityUser) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.releaseQty`]="{ item }">
                    <div class="mb-5">
                        <p class="my-0">
                            {{ item.releaseQty }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.reprocessQty`]="{ item }">
                    <div class="mb-5">
                        <p class="my-0">
                            {{ item.reprocessQty }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.rejectQty`]="{ item }">
                    <div class="mb-5">
                        <p class="my-0">
                            {{ item.rejectQty }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.NCcode`]="{ item }">
                    <div class="mb-5">
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <p class="my-0 text-center" v-on="on">
                                    {{ getNCCode(item.NCcode).code }}
                                </p>
                            </template>
                            <span>
                                Code:
                                {{ getNCCode(item.NCcode).code }}<br />
                                Type:
                                {{ getNCCode(item.NCcode).type }}<br />
                                Description:
                                {{ getNCCode(item.NCcode).description }}<br />
                            </span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-slot:[`item.actions`]="{ item, index }">
                    <div>
                        <v-btn
                            icon
                            @click.stop="openOverrideLogDialog(item, index)"
                            :disabled="loading"
                        >
                            <v-icon color="red">mdi-cancel</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
            <!-- Cancelled table -->
            <v-data-table
                :headers="cancelledHeaders"
                :items="cancelledItems"
                class="elevation-0 mt-7"
                :mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
                v-if="cancelledItems.length > 0"
            >
                <template v-slot:top>
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pt-4 pb-0 pb-4"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <v-col cols="6" class="d-flex align-center">
                            <h2
                                class="my-n3 d-flex align-center text-capitalize"
                            >
                                Cancelled {{ viewType }} Entries
                            </h2></v-col
                        >
                    </v-row>
                </template>
                <!--ITEMS-->
                <template v-slot:[`item.index`]="{ index }">
                    <p class="my-0">
                        {{ index + 1 }}
                    </p>
                </template>
                <template v-slot:[`item.date`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{
                                item.date
                                    ? formatDate(
                                          item.date.seconds ||
                                              item.date._seconds
                                      )
                                    : ''
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.cancelledOn`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{
                                item.cancelledOn
                                    ? formatDate(
                                          item.cancelledOn.seconds ||
                                              item.cancelledOn._seconds
                                      )
                                    : ''
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.cancelledBy`]="{ item }">
                    <div>
                        <p class="my-0">{{ getUserName(item.cancelledBy) }}</p>
                    </div>
                </template>
                <!-- PRODUCTION -->
                <template v-slot:[`item.operator`]="{ item }">
                    <div>
                        <p class="my-0">
                            {{ displayUser(item, item.operator) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.process`]="{ item }">
                    <div>
                        <p class="my-0">{{ item.process }}</p>
                    </div>
                </template>
                <template v-slot:[`item.machine`]="{ item }">
                    <div>
                        <p class="my-0">{{ item.machine }}</p>
                    </div>
                </template>
                <template v-slot:[`item.qty`]="{ item }">
                    <div>
                        <p class="my-0">{{ item.qty }}</p>
                    </div>
                </template>
                <!-- DELIVERY -->
                <template v-slot:[`item.originProcess`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ item.originProcess }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.originUser`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ displayUser(item, item.originUser) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.destinationProcess`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ item.destinationProcess }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.destUser`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ displayUser(item, item.destUser) }}
                        </p>
                    </div>
                </template>
                <!-- QUALITY -->
                <template v-slot:[`item.qualityUser`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0">
                            {{ getUserName(item.qualityUser) }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.releaseQty`]="{ item }">
                    <div class="mb-5">
                        <p class="my-0">
                            {{ item.releaseQty }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.reprocessQty`]="{ item }">
                    <div class="mb-5">
                        <p class="my-0">
                            {{ item.reprocessQty }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.rejectQty`]="{ item }">
                    <div class="mb-5">
                        <p class="my-0">
                            {{ item.rejectQty }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.NCcode`]="{ item }">
                    <div class="mb-5">
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <p class="my-0 text-center" v-on="on">
                                    {{ getNCCode(item.NCcode).code }}
                                </p>
                            </template>
                            <span>
                                Code:
                                {{ getNCCode(item.NCcode).code }}<br />
                                Type:
                                {{ getNCCode(item.NCcode).type }}<br />
                                Description:
                                {{ getNCCode(item.NCcode).description }}<br />
                            </span>
                        </v-tooltip>
                    </div>
                </template>
                <template v-slot:[`item.actions`]="{ item, index }">
                    <div>
                        <v-btn
                            icon
                            @click.stop="openOverrideLogDialog(item, index)"
                            :disabled="loading"
                        >
                            <v-icon color="red">mdi-cancel</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
        <!--Delete Item-->
        <v-dialog
            v-model="overrideDialog"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="overrideDialog">
                <v-card-title class="text-h5">
                    {{ `Override ${viewType} Log` }}</v-card-title
                >
                <v-card-text>
                    {{ dialogMessage }}
                    <v-form v-model="valid"
                        ><v-text-field
                            v-model="cancellReason"
                            label="Reason *"
                            :rules="[rules.required]"
                    /></v-form>
                </v-card-text>

                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="overrideDialog = false"
                        rounded
                    >
                        NO
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="overrideLog()"
                        text
                        color="error"
                        rounded
                        :loading="loading"
                        :disabled="!valid"
                    >
                        YES
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--Error Alert-->
        <Errors
            v-if="
                cancelledItems &&
                    items &&
                    cancelledItems.length + items.length > 5
            "
        />
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import moment from 'moment'
import _ from 'lodash'
export default {
    name: 'ItemLog',
    props: {
        selectedItem: {
            type: Object,
            required: true,
        },
        users: {
            type: Array,
            required: true,
        },
        viewType: {
            type: String,
            required: true,
        },
        workOrder: {
            type: Object,
            required: true,
        },
    },
    components: {
        Errors: () => import('@/components/Layout/Errors'),
    },
    data: () => ({
        headers: [],
        cancelledHeaders: [],
        productionHeaders: [
            {
                text: 'ID',
                value: 'index',
                align: 'center',
                sortable: false,
                width: '50',
            },
            {
                text: 'DATE',
                value: 'date',
                align: 'center',
                sortable: false,
            },
            {
                text: 'USER',
                value: 'operator',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PROCESS',
                value: 'process',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'MACHINE',
                value: 'machine',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QTY',
                value: 'qty',
                align: 'center',
                sortable: false,
            },
        ],
        deliveryHeaders: [
            {
                text: 'ID',
                value: 'index',
                align: 'center',
                sortable: false,
                width: '50',
            },
            {
                text: 'DATE',
                value: 'date',
                align: 'center',
                sortable: false,
            },
            {
                text: 'ORIGIN',
                value: 'originProcess',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DELIVERED BY',
                value: 'originUser',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESTINATION',
                value: 'destinationProcess',
                align: 'center',
                sortable: false,
            },
            {
                text: 'RECEIVED BY',
                value: 'destUser',
                align: 'center',
                sortable: false,
            },
            {
                text: 'RECEIVED ON',
                value: 'destUserOn',
                align: 'center',
                sortable: false,
            },
            {
                text: 'LOCATION',
                value: 'locationItem',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESTINATION WORK ORDER',
                value: 'destinationWorkOrder',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QTY',
                value: 'qty',
                align: 'center',
                sortable: false,
            },
        ],
        qualityHeaders: [
            {
                text: 'ID',
                value: 'index',
                align: 'center',
                sortable: false,
                width: '50',
            },
            {
                text: 'DATE',
                value: 'date',
                align: 'center',
                sortable: false,
            },
            {
                text: 'USER',
                value: 'qualityUser',
                align: 'center',
                sortable: false,
            },
            {
                text: 'RELEASED',
                value: 'releaseQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'REPROCESS',
                value: 'reprocessQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'REJECTED',
                value: 'rejectQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'NC CODE',
                value: 'NCcode',
                align: 'center',
                sortable: false,
            },
        ],
        height: 0,
        items: [],
        cancelledItems: [],
        ncCodes: [],
        packingProcess: {
            id: 'packing',
            name: 'packing',
        },
        loading: false,
        selectedEntry: {},
        selectedIndex: null,
        overrideDialog: false,
        rules: {
            required: v => !!v || 'Required',
        },
        valid: false,
        cancellReason: null,
        dialogMessage: '',
    }),

    async mounted() {
        try {
            this.loading = true
            const {
                data: { user },
            } = await API.getMyInfo()
            if (this.viewType == 'production') {
                this.headers = this.productionHeaders
                this.setProductionItems()
                this.cancelledHeaders = [
                    ...this.productionHeaders,
                    {
                        text: 'CANCELLED BY',
                        value: 'cancelledBy',
                        align: 'center',
                        sortable: false,
                    },
                    {
                        text: 'CANCELLED ON',
                        value: 'cancelledOn',
                        align: 'center',
                        sortable: false,
                    },
                    {
                        text: 'REASON',
                        value: 'reason',
                        align: 'center',
                        sortable: false,
                    },
                ]
            } else if (this.viewType == 'delivery') {
                this.headers = this.deliveryHeaders
                this.setDeliveryItems()
                this.cancelledHeaders = [
                    ...this.deliveryHeaders,
                    {
                        text: 'CANCELLED BY',
                        value: 'cancelledBy',
                        align: 'center',
                        sortable: false,
                    },
                    {
                        text: 'CANCELLED ON',
                        value: 'cancelledOn',
                        align: 'center',
                        sortable: false,
                    },
                    {
                        text: 'REASON',
                        value: 'reason',
                        align: 'center',
                        sortable: false,
                    },
                ]
            } else if (this.viewType == 'quality') {
                this.headers = this.qualityHeaders
                this.setQualityItems()
                this.cancelledHeaders = [
                    ...this.qualityHeaders,
                    {
                        text: 'CANCELLED BY',
                        value: 'cancelledBy',
                        align: 'center',
                        sortable: false,
                    },
                    {
                        text: 'CANCELLED ON',
                        value: 'cancelledOn',
                        align: 'center',
                        sortable: false,
                    },
                    {
                        text: 'REASON',
                        value: 'reason',
                        align: 'center',
                        sortable: false,
                    },
                ]
            }

            if (
                user &&
                user.permissions &&
                user.permissions.includes('updateWOProcesses') &&
                (this.workOrder.status == 'approved' ||
                    this.workOrder.status == 'finished')
            ) {
                this.headers.push({
                    text: 'ACTIONS',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                })
            }

            const {
                data: { settings },
            } = await API.getSettings()
            const setting = settings.find(
                setting => setting.name.toLowerCase() == 'quality'
            )
            this.ncCodes = setting.ncCodes
            this.items.sort(
                (a, b) =>
                    (b.date.seconds || b.date._seconds) -
                    (a.date.seconds || a.date._seconds)
            )
            this.onResize()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('closeDialog')
        },

        onResize() {
            this.height = window.innerHeight - 260
        },
        setProductionItems() {
            this.items = []
            if (this.selectedItem.production) {
                this.selectedItem.production.forEach(entry => {
                    this.items.push({
                        date: entry.producedOn,
                        operator: entry.producedBy,
                        process: entry.process.name,
                        machine: entry.machine.name,
                        qty: entry.qty,
                        registerId: entry.registerId,
                        user: entry.user || null,
                    })
                })
            }
            this.cancelledItems = []
            if (this.selectedItem.cancelledProduction) {
                this.selectedItem.cancelledProduction.forEach(entry => {
                    this.cancelledItems.push({
                        date: entry.producedOn,
                        operator: entry.producedBy,
                        process: entry.process.name,
                        machine: entry.machine.name,
                        qty: entry.qty,
                        cancelledBy: entry.cancelledBy,
                        cancelledOn: entry.cancelledOn,
                        reason: entry.reason,
                        user: entry.user || null,
                    })
                })
            }
        },
        setDeliveryItems() {
            this.items = []
            if (this.selectedItem.deliveries) {
                let deliveries = this.selectedItem.deliveries
                if (this.$router.currentRoute.name == 'packing-balance') {
                    deliveries = deliveries.filter(
                        item =>
                            item.receivedBy &&
                            item.nextProcess.id == this.packingProcess.id
                    )
                }
                deliveries.forEach(entry => {
                    this.items.push({
                        date: entry.deliveredOn,
                        originProcess: entry.prevProcess.name,
                        originUser: entry.deliveredBy,
                        destinationProcess: entry.nextProcess.name,
                        destinationWorkOrder: entry.destinationWorkOrder,
                        destUser: entry.receivedBy,
                        destUserOn: entry.receivedOn,
                        qty: entry.qty,
                        locationItem: entry.locationItem,
                        deliveryId: entry.deliveryId,
                        user: entry.user || null,
                    })
                })
            }
            this.cancelledItems = []
            if (this.selectedItem.cancelledDeliveries) {
                let deliveries = this.selectedItem.cancelledDeliveries
                if (this.$router.currentRoute.name == 'packing-balance') {
                    deliveries = deliveries.filter(
                        item =>
                            item.receivedBy &&
                            item.nextProcess.id == this.packingProcess.id
                    )
                }
                deliveries.forEach(entry => {
                    this.cancelledItems.push({
                        date: entry.deliveredOn,
                        originProcess: entry.prevProcess.name,
                        originUser: entry.deliveredBy,
                        destinationProcess: entry.nextProcess.name,
                        destinationWorkOrder: entry.destinationWorkOrder,
                        destUser: this.formatDate(entry.receivedBy),
                        qty: entry.qty,
                        locationItem: entry.locationItem,
                        cancelledBy: entry.cancelledBy,
                        cancelledOn: entry.cancelledOn,
                        reason: entry.reason,
                        user: entry.user || null,
                    })
                })
            }
        },
        setQualityItems() {
            this.items = []
            if (this.selectedItem.quality) {
                this.selectedItem.quality.forEach(entry => {
                    this.items.push({
                        date: entry.qualityReviewedOn,
                        qualityUser: entry.qualityReviewedBy,
                        releaseQty: entry.releaseQty || 0,
                        reprocessQty: entry.reprocessQty || 0,
                        rejectQty: entry.rejectQty || 0,
                        NCcode: entry.NCcode || '',
                        registerId: entry.registerId,
                    })
                })
            }
            this.cancelledItems = []
            if (this.selectedItem.cancelledQuality) {
                this.selectedItem.cancelledQuality.forEach(entry => {
                    this.cancelledItems.push({
                        date: entry.qualityReviewedOn,
                        qualityUser: entry.qualityReviewedBy,
                        releaseQty: entry.releaseQty || 0,
                        reprocessQty: entry.reprocessQty || 0,
                        rejectQty: entry.rejectQty || 0,
                        NCcode: entry.NCcode || '',
                        reason: entry.reason || '',
                        cancelledBy: entry.cancelledBy,
                        cancelledOn: entry.cancelledOn,
                    })
                })
            }
        },
        getUserName(id) {
            let userName = ''
            const user = this.users.find(u => u.id == id)
            if (user) {
                userName = user.name
            }
            return userName
        },
        // Entries created through the client integration carry the client's own
        // user, which is not in our users collection.
        displayUser(item, fallbackId) {
            const clientUser = item.user
            if (clientUser) {
                return typeof clientUser == 'string'
                    ? clientUser
                    : clientUser.name
            }
            return this.getUserName(fallbackId)
        },
        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD HH:mm')
        },
        getNCCode(id) {
            let code = { code: id, type: id, description: id }
            const foundCode = this.ncCodes.find(c => c.id == id)
            if (foundCode) {
                code = foundCode
            }
            return code
        },
        openOverrideLogDialog(entry, index) {
            this.selectedEntry = _.cloneDeep(entry)
            this.selectedIndex = _.cloneDeep(index)
            this.dialogMessage = `Are you sure you want to override this ${this.viewType} log?`
            if (entry.qty < 0) {
                this.dialogMessage = `Are you sure you want to override this ${
                    this.viewType
                } log? This will remove the associated ${
                    this.viewType == 'production'
                        ? 'returned delivery entry'
                        : 'reprocess production entry'
                }.`
            }
            this.cancelReason = null
            this.overrideDialog = true
        },
        async overrideLog() {
            try {
                this.loading = true
                const cancelledLog = await API.overrideLog({
                    workOrderId: this.workOrder.id,
                    partNumberId: this.selectedItem.partNumberId,
                    type: this.viewType,
                    entry: this.selectedEntry,
                    reason: this.cancellReason,
                })
                cancelledLog.date =
                    cancelledLog.producedOn ||
                    cancelledLog.deliveredOn ||
                    cancelledLog.qualityReviewedOn

                cancelledLog.operator = cancelledLog.producedBy || ''
                cancelledLog.originUser = cancelledLog.deliveredBy || ''
                cancelledLog.qualityUser = cancelledLog.qualityReviewedBy || ''

                cancelledLog.originProcess = cancelledLog.prevProcess
                    ? cancelledLog.prevProcess.name
                    : ''
                cancelledLog.destinationProcess = cancelledLog.nextProcess
                    ? cancelledLog.nextProcess.name
                    : ''

                Object.keys(cancelledLog).forEach(key => {
                    if (
                        typeof cancelledLog[key] == 'object' &&
                        cancelledLog[key].name
                    ) {
                        cancelledLog[key] = cancelledLog[key].name
                    }
                })
                this.items.splice(this.selectedIndex, 1)
                this.cancelledItems.push(cancelledLog)
                this.selectedEntry = _.cloneDeep({})
                this.selectedIndex = null
                this.overrideDialog = false
                this.cancellReason = null
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style></style>
